export default __webpack_public_path__ + "static/media/check.1acff773.svg";